import { render, staticRenderFns } from "./Page3Pdf3.vue?vue&type=template&id=4fcdaba9&scoped=true&"
import script from "./Page3Pdf3.vue?vue&type=script&lang=js&"
export * from "./Page3Pdf3.vue?vue&type=script&lang=js&"
import style0 from "./Page3Pdf3.vue?vue&type=style&index=0&id=4fcdaba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcdaba9",
  null
  
)

export default component.exports